import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal, useAccount } from '@azure/msal-react';
import { useCallback, useContext } from 'react';
import { loginRequest } from './msalConfig';
import { AppContext } from '@/utils/appContext';


export const useAuth = () => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const activeAccount = useAccount(accounts[0] ?? null);

  const handleLogin = useCallback(async () => {
    if (inProgress === InteractionStatus.None) {
      await instance.loginRedirect(loginRequest);
    }
  }, [instance, inProgress]);

  const handleLogout = useCallback(async () => {
    if (inProgress === InteractionStatus.None) {
      await instance.logoutRedirect();
    }
  }, [instance, inProgress]);

  return {
    isAuthenticated,
    activeAccount,
    accounts,
    inProgress,
    handleLogin,
    handleLogout,
  };
};
